module.exports = __webpack_public_path__ + "static/media/profile-picture-3.55d8a646.jpg";